// removed by extract-text-webpack-plugin
module.exports = {"container":"_2RLlb","input":"Qg0lZ"};


//////////////////
// WEBPACK FOOTER
// ./app/components/share-link/share-link.scss
// module id = 882
// module chunks = 3 4 5 6 7